/*
 * @Author: WLL
 * @Date: 2020-04-29 14:06:28
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-01 10:50:59
 * @Description: 机构关注行业页面接口
 */
import http from "@/utils/http";

export default {
  async getIndustryChart(params) {
    return await http.post("agency/industry/chart", {
      pageNo: 1,
      pageSize: null,
      ...params
    });
  },
  async getIndustryList(params) {
    return await http.post("agency/industry/industry_list", params);
  },
  async getConceptChart(params) {
    return await http.post("agency/concept/chart", {
      pageNo: 1,
      pageSize: null,
      ...params
    });
  },
  async getConceptList(params) {
    return await http.post("agency/concept/concept_list", params);
  }
};
